module.exports = __webpack_public_path__ + "static/groupdesign-84baaa3d99da4e0c43c1c2aea63db79c.png";